import { Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import PaymentForm from "../../components/PaymentForm";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useSelector } from 'react-redux';


const SiteLayout = styled(Grid)(({ theme }) => ({
  background: `url('/assets/Skiing-Image-QQF.jpg')`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  padding: '0 16px',
  [theme.breakpoints.up("sm")]: {
    padding: '0 32px',
  },
  [theme.breakpoints.up("md")]: {
    padding: '0 64px',
  },
  [theme.breakpoints.up("lg")]: {
    padding: '0 100px',
  },
}));




const SiteLayoutContent = styled(Box)(({ theme }) => ({
  padding: "24px",
  margin: "16px 0",
  minHeight: "222px",
  background: "#fff",
  borderRadius: "10px",
  display: "block",
    maxWidth:'1500px'
}));

export default function Payment() {
  const createBookingResponse = useSelector(state => state.createBooking);

  const paypalKey = process.env.REACT_APP_PAYPAL_KEY;
  return (
    <SiteLayout container>
     
      <Grid item xs={12} display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <SiteLayoutContent>
        <PayPalScriptProvider options={{
                "client-id": paypalKey,
                "currency": createBookingResponse.basket.currency[0],
                "disable-funding": "bancontact,eps,giropay,ideal,mybank,p24,sepa,sofort,venmo,wechatpay" // Disable all except credit cards and PayPal
              }}>
           <PaymentForm />
           </PayPalScriptProvider>
        </SiteLayoutContent>
      </Grid>
    </SiteLayout>
  );
}
